const PRODUCT_GIFTCARD_TYPE_PHYSICAL = 'Physical' // Duplicated from @bluheadless/ui-logic
;
const MANAGE_GIFTCARD_TYPES = false // Duplicated from @bluheadless/ui-logic
;
const transformGiftCardOptions = (giftcard_options, productData)=>{
    if (!giftcard_options) {
        return null;
    }
    const openAmount = parseFloat(giftcard_options?.custom_giftcard_amount) || null;
    const giftcardPhysical = productData?.giftcardOptions?.type === PRODUCT_GIFTCARD_TYPE_PHYSICAL;
    return {
        amount: parseFloat(giftcard_options?.giftcard_amount) || null,
        ...productData?.giftcardOptions?.openAmount?.allowed ? {
            openAmount
        } : {},
        ...productData?.giftcardOptions?.allowMessage ? {
            message: giftcard_options?.giftcard_message
        } : {},
        ...!giftcardPhysical || !MANAGE_GIFTCARD_TYPES ? {
            recipientEmail: giftcard_options?.giftcard_recipient_email || '',
            recipientName: giftcard_options?.giftcard_recipient_name || '',
            senderEmail: giftcard_options?.giftcard_sender_email || '',
            senderName: giftcard_options?.giftcard_sender_name || ''
        } : {}
    };
};
const transformGiftCardOptionsRequest = (giftcard_options)=>{
    return {
        giftcard_amount: giftcard_options?.amount ? giftcard_options?.amount?.toFixed?.(4)?.toString?.() : '',
        ...giftcard_options?.openAmount ? {
            custom_giftcard_amount: parseFloat(giftcard_options?.openAmount)
        } : {},
        giftcard_message: giftcard_options?.message || '',
        giftcard_recipient_email: giftcard_options?.recipientEmail || '',
        giftcard_recipient_name: giftcard_options?.recipientName || '',
        giftcard_sender_email: giftcard_options?.senderEmail || '',
        giftcard_sender_name: giftcard_options?.senderName || ''
    };
};

export { transformGiftCardOptions, transformGiftCardOptionsRequest };
